import { IStatesInitialState } from "../Interfaces/IStates";

export const StatesInitialState: IStatesInitialState = {
    isLoadingStatesDashboard: false,
    states: []
}